<template>
	<div class='app-wrapper'>
		<navbar></navbar>
		<sidebar class='sidebar-container' v-show="sidebar.isShow"></sidebar>
		<div id="main-container" :class="sidebar.isShow?'main-container-showSideBar':'main-container'">
			<app-main></app-main>
		</div>
	</div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from '@/components/layout';
import { IsPC } from '@/utils';

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mounted() {
    document.getElementById('main-container').style.height = document.body.clientHeight - 20 + 'px'
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    }
  },
  methods: {
    IsPC() {
      return IsPC();
    }
  }
};
</script>

<style rel='stylesheet/scss' lang='scss' scoped>
@import '~styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  min-width: 1362px;
  height: 100%;
  width: 100%;
  background: #f7f7f7;
  &.hideSidebar {
    .sidebar-container {
      width: 0px;
      display: none;
      overflow: inherit;
    }
    .main-container {
      margin-left: 0px;
    }
  }
  .sidebar-container {
    transition: width 0.28s ease-out;
    width: 180px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .app-main{
    background: rgba(248,248,251,1);
  }
  .main-container {
    // min-height: 90%;
    transition: margin-left 0.28s ease-out;
    margin-left:25px;
    padding-top: 70px;
    margin-right: 25px;
    background: #f7f7f7;
    // padding: 5px 15px;
  }
  .main-container-showSideBar {
    // min-height: 90%;
    transition: margin-left 0.28s ease-out;
    margin-left:205px;
    padding-top: 70px;
    margin-right: 25px;
    background: #f7f7f7;
    // padding: 5px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// Layout.vue?3d72451a